import "./brand-vehicle-list-tile.scss";
import React from "react";
import { Link } from "gatsby";

const BrandVehicleListTile = ({
  name,
  description,
  image,
  type,
  producentLink,
  available,
  link,
  index,
}) => {
  return (
    <div className="vehicle-list-tile" id={index}>
      <div className="vehicle-list-tile__image-container">
        <img
          src={image}
          alt=""
          className="vehicle-list-tile__image img-fluid"
        />
      </div>
      <div className="vehicle-list-tile__info-container">
        <div className="vehicle-list-tile__header-container">
          <div>
            <div className="vehicle-list-tile__name">{name}</div>
            <div className="vehicle-list-tile__type">
              {type[0] === "polintegra"
                ? "półintegra"
                : type[0] === "integra"
                ? "integra"
                : type[0] === "przyczepa"
                ? "przyczepa"
                : "kamper-van"}
            </div>
          </div>
          <div className="vehicle-list-tile__buttons-container">
            {available !== true && (
              <a
                href={producentLink}
                target="_blank"
                rel="noreferrer"
                className="btn btn--small"
              >
                więcej informacji
              </a>
            )}
            {available && (
              <Link
                to={link}
                className="btn btn--available btn--available-small"
              >
                dostępny od ręki!
              </Link>
            )}
          </div>
        </div>
        <div
          className="vehicle-list-tile__desc"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    </div>
  );
};

export default BrandVehicleListTile;
